import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const InvoiceIdSchema = z.string().brand<'invoice-id'>()

export type InvoiceId = ZodSimplify<typeof InvoiceIdSchema>

export const InvoiceId = (value: string = generateRandomString()) => {
  return InvoiceIdSchema.parse(value)
}
